import { useAuth } from "../context/AuthContext";
import { Card, CardHeader } from "../components/ui/Card";
import { Badge } from "../components/ui/Badge";
import { ChangePasswordForm } from "../components/auth/ChangePasswordForm";

export default function Profile() {
  const { user } = useAuth();

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <Card>
        <CardHeader title="Mein Profil" subtitle="Ihre Kontodaten" />
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div><p className="label">Name</p><p className="text-gray-200">{user?.fullName}</p></div>
          <div><p className="label">Benutzername</p><p className="text-gray-200">{user?.username}</p></div>
          <div><p className="label">Rolle</p><Badge tone="accent">{user?.roleName}</Badge></div>
        </div>
      </Card>

      <Card>
        <CardHeader title="Passwort ändern" />
        <ChangePasswordForm />
      </Card>
    </div>
  );
}
